import React from "react";
import { useFeatureToggle } from "./useFeatureToggle";

type FeatureToggleProps = {
  flag: string;
  NewComponent?: React.ReactNode;
  OldComponent?: React.ReactNode;
  children?: React.ReactNode;
};

export const FeatureToggle: React.FC<FeatureToggleProps> & {
  withLogic: <T>(
    flagValue: boolean,
    options: {
      onNew?: () => T;
      onOld?: () => T;
      onNone?: () => T;
    }
  ) => T | null;
} = ({ flag, NewComponent, OldComponent, children }) => {
  const isEnabled = useFeatureToggle(flag);

  if (isEnabled && NewComponent) return <>{NewComponent}</>;
  if (!isEnabled && OldComponent) return <>{OldComponent}</>;
  return <>{children ?? null}</>;
};

FeatureToggle.withLogic = <T,>(
  isEnabled: boolean,
  {
    onNew,
    onOld,
    onNone
  }: {
    onNew?: () => T;
    onOld?: () => T;
    onNone?: () => T;
  }
): T | null => {
  if (isEnabled && onNew) return onNew();
  if (!isEnabled && onOld) return onOld();
  if (onNone) return onNone();
  return null;
};
